import StyleCategories from "./StyleCategories";
import UpdateStyleCategory from "./UpdateStyleCategory";

export { StyleCategories, UpdateStyleCategory };
